var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.164 2.78627L23.3346 1.25314V15.0921L30.5782 16.4839C32.3553 9.34556 32.2964 4.64832 32.164 2.78899V2.78627ZM2.3716 18.9793C3.07772 20.9365 4.081 22.6843 5.2667 24.2283L16.1115 22.1461L26.9564 24.2283C28.1421 22.6871 29.1424 20.9365 29.8515 18.9793L16.1115 16.3425L2.3716 18.9793ZM20.5424 14.5539V0.769283L16.1115 0L11.6836 0.769283V14.5539L16.1115 13.703L20.5395 14.5539H20.5424ZM7.26443 26.4791C9.99477 29.1648 13.2488 31.0024 16.1115 32C18.9743 31.0024 22.2283 29.1648 24.9586 26.4791L16.1115 24.7802L7.26443 26.4791ZM8.88851 1.25314L0.0590539 2.78627C-0.0733438 4.64288 -0.132187 9.34285 1.64194 16.4811L8.88557 15.0894V1.25314H8.88851Z",
    fill: "url(#paint0_linear_133_283)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_283",
    x1: 0.000210439,
    y1: 16.0027,
    x2: 32.2229,
    y2: 16.0027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8075F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8AEF8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.91347af6e76ec1ac1f8c13e62c3b856e.svg";
export { ForwardRef as ReactComponent };